import axios from '../../../../services/axios';

export function getFailedJobs(params) {
  return axios.get('/api/dashboard/failed-jobs', params);
}

export function retryFailedJob(id) {
  return axios.post(`/api/dashboard/failed-jobs/${id}/retry`);
}
